/**
 * Localization strings used in the Schema Config and data model viewer
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const schemaText = createDictionary({
  table: {
    'en-us': 'Table',
    'ru-ru': 'Стол',
    'es-es': 'Mesa',
    'fr-fr': 'Tableau',
    'uk-ua': 'Таблиця',
    'de-ch': 'Tabelle',
    'pt-br': 'Mesa',
    'hr-hr': 'Stol',
    nb: 'Bord',
  },
  tables: {
    'en-us': 'Tables',
    'ru-ru': 'Таблицы',
    'es-es': 'Tablas',
    'fr-fr': 'Tables',
    'uk-ua': 'Столи',
    'de-ch': 'Tabellen',
    'pt-br': 'Tabelas',
    'hr-hr': 'Tablice',
    nb: 'Tabeller',
  },
  tableName: {
    'en-us': 'Table Name',
    'ru-ru': 'Название таблицы',
    'fr-fr': 'Nom de la table',
    'uk-ua': 'Назва таблиці',
    'de-ch': 'Tabellennamen',
    'es-es': 'Nombre de la tabla',
    'pt-br': 'Nome da tabela',
    'hr-hr': 'Naziv tablice',
    nb: 'Tabellnavn',
  },
  withoutTable: {
    'en-us': 'Without Table',
    'de-ch': 'Ohne Tisch',
    'es-es': 'Sin mesa',
    'fr-fr': 'Sans table',
    'ru-ru': 'Без стола',
    'uk-ua': 'Без столу',
    'pt-br': 'Sem mesa',
    'hr-hr': 'Bez stola',
    nb: 'Uten bord',
  },
  schemaConfig: {
    'en-us': 'Schema Config',
    'ru-ru': 'Конфигурация схемы',
    'es-es': 'Configuración del esquema',
    'fr-fr': 'Configuration du schéma',
    'uk-ua': 'Конфігурація схеми',
    'de-ch': 'Schema konfigurieren',
    'pt-br': 'Configuração do esquema',
    'hr-hr': 'Konfiguracija sheme',
    nb: 'Skjemakonfigurasjon',
  },
  unsavedSchemaUnloadProtect: {
    'en-us': 'Schema changes have not been saved',
    'ru-ru': 'Изменения в схеме не были сохранены.',
    'es-es': 'Los cambios de esquema no se han guardado.',
    'fr-fr': "Les modifications de schéma n'ont pas été enregistrées.",
    'uk-ua': 'Зміни схеми не збережено',
    'de-ch': 'Schema Änderungen wurden nicht gespeichert',
    'pt-br': 'As alterações de esquema não foram salvas.',
    'hr-hr': 'Promjene sheme nisu spremljene',
    nb: 'Skjemaendringer er ikke lagret',
  },
  changeBaseTable: {
    'en-us': 'Change Base Table',
    'ru-ru': 'Изменить базовую таблицу',
    'es-es': 'Tabla base de cambios',
    'fr-fr': 'Modifier la table de base',
    'uk-ua': 'Змінити базову таблицю',
    'de-ch': 'Basis-Tabelle ändern',
    'pt-br': 'Alterar tabela base',
    'hr-hr': 'Promijeni osnovnu tablicu',
    nb: 'Endre basistabell',
  },
  field: {
    'en-us': 'Field',
    'ru-ru': 'Поле',
    'es-es': 'Campo',
    'fr-fr': 'Champ',
    'uk-ua': 'Поле',
    'de-ch': 'Feld',
    'pt-br': 'Campo',
    'hr-hr': 'Polje',
    nb: 'Felt',
  },
  fields: {
    'en-us': 'Fields',
    'ru-ru': 'Поля',
    'es-es': 'Campos',
    'fr-fr': 'Champs',
    'uk-ua': 'Поля',
    'de-ch': 'Felder',
    'pt-br': 'Campos',
    'hr-hr': 'Polja',
    nb: 'Felt',
  },
  relationships: {
    'en-us': 'Relationships',
    'ru-ru': 'Отношения',
    'es-es': 'Relaciones',
    'fr-fr': 'Relations',
    'uk-ua': 'Стосунки',
    'de-ch': 'Beziehungen',
    'pt-br': 'Relacionamentos',
    'hr-hr': 'Odnosi',
    nb: 'Relasjoner',
  },
  database: {
    'en-us': 'Database',
    'de-ch': 'Datenbank',
    'fr-fr': 'Base de données',
    'ru-ru': 'База данных',
    'uk-ua': 'База даних',
    'es-es': 'Base de datos',
    'pt-br': 'Banco de dados',
    'hr-hr': 'Baza podataka',
    nb: 'Database',
  },
  setScope: {
    'en-us': 'Set Scope',
    'de-ch': 'Zielbereich einstellen',
    'es-es': 'Establecer alcance',
    'fr-fr': 'Définir le périmètre',
    'ru-ru': 'Установить область действия',
    'uk-ua': 'Встановити область дії',
    'pt-br': 'Definir Escopo',
    'hr-hr': 'Postavi opseg',
    nb: 'Angi omfang',
  },
  caption: {
    'en-us': 'Caption',
    'ru-ru': 'Подпись',
    'es-es': 'Subtítulo',
    'fr-fr': 'Légende',
    'uk-ua': 'Підпис',
    'de-ch': 'Beschriftung',
    'pt-br': 'Rubrica',
    'hr-hr': 'Naslov',
    nb: 'Tekst',
  },
  description: {
    'en-us': 'Description',
    'ru-ru': 'Описание',
    'es-es': 'Descripción',
    'fr-fr': 'Description',
    'uk-ua': 'Опис',
    'de-ch': 'Beschreibung',
    'pt-br': 'Descrição',
    'hr-hr': 'Opis',
    nb: 'Beskrivelse',
  },
  hideTable: {
    'en-us': 'Hide Table',
    'ru-ru': 'Скрыть таблицу',
    'es-es': 'Ocultar tabla',
    'fr-fr': 'Masquer la table',
    'uk-ua': 'Приховати таблицю',
    'de-ch': 'Tabelle verbergen',
    'pt-br': 'Ocultar tabela',
    'hr-hr': 'Sakrij tablicu',
    nb: 'Skjul tabell',
  },
  hideField: {
    'en-us': 'Hide Field',
    'ru-ru': 'Скрыть поле',
    'es-es': 'Ocultar campo',
    'fr-fr': 'Masquer le champ',
    'uk-ua': 'Приховати поле',
    'de-ch': 'Feld verbergen',
    'pt-br': 'Ocultar campo',
    'hr-hr': 'Sakrij polje',
    nb: 'Skjul felt',
  },
  tableFormat: {
    'en-us': 'Table Format',
    'ru-ru': 'Формат таблицы',
    'es-es': 'Formato de tabla',
    'fr-fr': 'Format de table',
    'uk-ua': 'Формат таблиці',
    'de-ch': 'Tabellenformat',
    'pt-br': 'Formato de tabela',
    'hr-hr': 'Format tablice',
    nb: 'Tabellformat',
  },
  tableAggregation: {
    'en-us': 'Table Aggregation',
    'ru-ru': 'Агрегирование таблиц',
    'es-es': 'Agregación de tablas',
    'fr-fr': 'Agrégation entre tables',
    'uk-ua': 'Агрегація таблиць',
    'de-ch': 'Tabellenaggregation',
    'pt-br': 'Agregação de tabelas',
    'hr-hr': 'Agregacija tablica',
    nb: 'Tabellaggregering',
  },
  oneToOne: {
    'en-us': 'One-to-one',
    'ru-ru': 'Один на один',
    'es-es': 'Cara a cara',
    'fr-fr': 'Un à un',
    'uk-ua': 'Один на один',
    'de-ch': 'Eins zu eins',
    'pt-br': 'Um para um',
    'hr-hr': 'Jedan na jedan',
    nb: 'En-til-en',
  },
  oneToMany: {
    'en-us': 'One-to-many',
    'ru-ru': 'Один ко многим',
    'es-es': 'De uno a muchos',
    'fr-fr': 'Un à plusieurs',
    'uk-ua': 'Один до багатьох',
    'de-ch': 'Eins zu vielen',
    'pt-br': 'Um para muitos',
    'hr-hr': 'Jedan-na-mnogo',
    nb: 'En-til-mange',
  },
  manyToOne: {
    'en-us': 'Many-to-one',
    'ru-ru': 'Многие к одному',
    'es-es': 'Muchos a uno',
    'fr-fr': 'Plusieurs vers un',
    'uk-ua': 'Багато до одного',
    'de-ch': 'Viele zu eins',
    'pt-br': 'Muitos para um',
    'hr-hr': 'Više prema jedan',
    nb: 'Mange-til-en',
  },
  manyToMany: {
    'en-us': 'many-to-many',
    'ru-ru': 'многие ко многим',
    'es-es': 'muchos a muchos',
    'fr-fr': 'plusieurs à plusieurs',
    'uk-ua': 'багато-до-багатьох',
    'de-ch': 'Viele zu viele',
    'pt-br': 'muitos para muitos',
    'hr-hr': 'mnogo-na-mnogo',
    nb: 'mange-til-mange',
  },
  fieldLength: {
    'en-us': 'Length',
    'es-es': 'Longitud',
    'fr-fr': 'Longueur',
    'uk-ua': 'Довжина',
    'de-ch': 'Länge',
    'ru-ru': 'Длина',
    'pt-br': 'Comprimento',
    'hr-hr': 'Duljina',
    nb: 'Lengde',
  },
  readOnly: {
    'en-us': 'Read-only',
    'ru-ru': 'Только для чтения',
    'es-es': 'Solo lectura',
    'fr-fr': 'Lecture seule',
    'uk-ua': 'Тільки для читання',
    'de-ch': 'Nur-Lesen',
    'pt-br': 'Somente leitura',
    'hr-hr': 'Samo za čitanje',
    nb: 'Skrivebeskyttet',
  },
  fieldFormat: {
    'en-us': 'Field Format',
    'ru-ru': 'Формат поля',
    'es-es': 'Formato de campo',
    'fr-fr': 'Format du champ',
    'uk-ua': 'Формат поля',
    'de-ch': 'Feldformat',
    'pt-br': 'Formato do campo',
    'hr-hr': 'Format polja',
    nb: 'Feltformat',
  },
  uiFormattersForField: {
    'en-us': 'Field Formatters for {fieldLabel:string}',
    'de-ch': 'Feldformatierer für {fieldLabel:string}',
    'es-es': 'Formateadores de campo para {fieldLabel:string}',
    'fr-fr': 'Formateurs de champs pour {fieldLabel:string}',
    'pt-br': 'Formatadores de campo para {fieldLabel:string}',
    'ru-ru': 'Форматирование полей для {fieldLabel:string}',
    'uk-ua': 'Форматування полів для {fieldLabel:string}',
    'hr-hr': 'Formateri polja za {fieldLabel:string}',
    nb: 'Feltformateringer for {fieldLabel:string}',
  },
  formatted: {
    'en-us': 'Formatted',
    'ru-ru': 'Отформатированный',
    'es-es': 'Formateado',
    'fr-fr': 'Formaté',
    'uk-ua': 'Відформатовано',
    'de-ch': 'Formatiert',
    'pt-br': 'Formatado',
    'hr-hr': 'Formatirano',
    nb: 'Formatert',
  },
  webLink: {
    'en-us': 'Web Link',
    'ru-ru': 'Веб-ссылка',
    'es-es': 'Enlace web',
    'fr-fr': 'Lien Web',
    'uk-ua': 'Веб-посиланні',
    'de-ch': 'Web-Link',
    'pt-br': 'Link da Web',
    'hr-hr': 'Web-veza',
    nb: 'Nettlenke',
  },
  userDefined: {
    'en-us': 'User Defined',
    'es-es': 'Definido por el usuario',
    'fr-fr': "Défini par l'utilisateur",
    'uk-ua': 'Визначено користувачем',
    'de-ch': 'Benutzerdefiniert',
    'ru-ru': 'Определяется пользователем',
    'pt-br': 'Definido pelo usuário',
    'hr-hr': 'Korisnički definirano',
    nb: 'Brukerdefinert',
  },
  addLanguage: {
    'en-us': 'Add Language',
    'fr-fr': 'Ajouter une langue',
    'uk-ua': 'Додати мову',
    'de-ch': 'Sprache hinzuzufügen',
    'es-es': 'Agregar idioma',
    'ru-ru': 'Добавить язык',
    'pt-br': 'Adicionar idioma',
    'hr-hr': 'Dodaj jezik',
    nb: 'Legg til språk',
  },
  databaseColumn: {
    'en-us': 'Database Column',
    'ru-ru': 'Столбец базы данных',
    'es-es': 'Columna de base de datos',
    'fr-fr': 'Colonne de base de données',
    'uk-ua': 'Стовпець бази даних',
    'de-ch': 'Datenbank-Spalte',
    'pt-br': 'Coluna do banco de dados',
    'hr-hr': 'Stupac baze podataka',
    nb: 'Databasekolonne',
  },
  relatedTable: {
    'en-us': 'Related Model',
    'ru-ru': 'Соответствующая модель',
    'es-es': 'Modelo relacionado',
    'fr-fr': 'Modèle associé',
    'uk-ua': "Пов'язана модель",
    'de-ch': 'Zugehöriges Modell',
    'pt-br': 'Modelo relacionado',
    'hr-hr': 'Povezani model',
    nb: 'Relatert modell',
  },
  otherSideName: {
    'en-us': 'Other side name',
    'ru-ru': 'Название другой стороны',
    'fr-fr': "Nom de l'autre côté",
    'uk-ua': 'Інша назва сторони',
    'de-ch': 'Name der anderen Seite',
    'es-es': 'Nombre del otro lado',
    'pt-br': 'Outro nome do lado',
    'hr-hr': 'Drugo bočno ime',
    nb: 'Andre sidenavn',
  },
  dependent: {
    'en-us': 'Dependent',
    'ru-ru': 'Зависимый',
    'es-es': 'Dependiente',
    'fr-fr': 'Dépendant',
    'uk-ua': 'Утриманець',
    'de-ch': 'Abhängig',
    'pt-br': 'Dependente',
    'hr-hr': 'Ovisnik',
    nb: 'Avhengig',
  },
  independent: {
    'en-us': 'Independent',
    'es-es': 'Independiente',
    'fr-fr': 'Indépendant',
    'ru-ru': 'Независимый',
    'uk-ua': 'Незалежний',
    'de-ch': 'Unabhängig',
    'pt-br': 'Independente',
    'hr-hr': 'Neovisni',
    nb: 'Selvstendig',
  },
  downloadAsJson: {
    'en-us': 'Download as JSON',
    'ru-ru': 'Скачать в формате JSON',
    'es-es': 'Descargar como JSON',
    'fr-fr': 'Télécharger au format JSON',
    'uk-ua': 'Завантажити як JSON',
    'de-ch': 'Als JSON herunterladen',
    'pt-br': 'Baixar como JSON',
    'hr-hr': 'Preuzmi kao JSON',
    nb: 'Last ned som JSON',
  },
  downloadAsTsv: {
    'en-us': 'Download as TSV',
    'ru-ru': 'Скачать в формате TSV',
    'es-es': 'Descargar como TSV',
    'fr-fr': 'Télécharger au format TSV',
    'uk-ua': 'Завантажити як TSV',
    'de-ch': 'Als TSV herunterladen',
    'pt-br': 'Baixar como TSV',
    'hr-hr': 'Preuzmi kao TSV',
    nb: 'Last ned som TSV',
  },
  tableId: {
    'en-us': 'Table ID',
    'ru-ru': 'Идентификатор таблицы',
    'es-es': 'ID de tabla',
    'fr-fr': 'ID de la table',
    'uk-ua': 'Ідентифікатор таблиці',
    'de-ch': 'Tabellen-ID',
    'pt-br': 'ID da tabela',
    'hr-hr': 'ID tablice',
    nb: 'Tabell-ID',
  },
  fieldCount: {
    'en-us': 'Field count',
    'ru-ru': 'Количество полей',
    'es-es': 'Recuento de campos',
    'fr-fr': 'Nombre de champs',
    'uk-ua': 'Кількість полів',
    'de-ch': 'Anzahl Felder',
    'pt-br': 'Contagem de campos',
    'hr-hr': 'Broj polja',
    nb: 'Antall felt',
  },
  relationshipCount: {
    'en-us': 'Relationship count',
    'ru-ru': 'Количество отношений',
    'es-es': 'Recuento de relaciones',
    'fr-fr': 'Nombre de relations',
    'uk-ua': "Кількість зв'язків",
    'de-ch': 'Anzahl Beziehungen',
    'pt-br': 'Contagem de relacionamentos',
    'hr-hr': 'Broj odnosa',
    nb: 'Antall relasjoner',
  },
  databaseSchema: {
    'en-us': 'Database Schema',
    'ru-ru': 'Схема базы данных',
    'es-es': 'Esquema de la base de datos',
    'fr-fr': 'Schéma de base de données',
    'uk-ua': 'Схема бази даних',
    'de-ch': 'Datenbankschema',
    'pt-br': 'Esquema do banco de dados',
    'hr-hr': 'Shema baze podataka',
    nb: 'Databaseskjema',
  },
  selectedTables: {
    'en-us': 'Selected Tables',
    'ru-ru': 'Избранные таблицы',
    'es-es': 'Tablas seleccionadas',
    'fr-fr': 'Tables sélectionnées',
    'uk-ua': 'Вибрані таблиці',
    'de-ch': 'Ausgewählte Tabellen',
    'pt-br': 'Tabelas selecionadas',
    'hr-hr': 'Odabrane tablice',
    nb: 'Valgte tabeller',
  },
  possibleTables: {
    'en-us': 'Possible Tables',
    'ru-ru': 'Возможные таблицы',
    'es-es': 'Tablas posibles',
    'fr-fr': 'Tables possibles',
    'uk-ua': 'Можливі таблиці',
    'de-ch': 'Mögliche Tabellen',
    'pt-br': 'Tabelas possíveis',
    'hr-hr': 'Moguće tablice',
    nb: 'Mulige tabeller',
  },
  goToTop: {
    'en-us': 'Go to top',
    'es-es': 'Ir al inicio',
    'fr-fr': 'Retour en haut',
    'uk-ua': 'Перейти на початок',
    'de-ch': 'Nach oben',
    'ru-ru': 'Перейти наверх',
    'pt-br': 'Voltar ao topo',
    'hr-hr': 'Idi na vrh',
    nb: 'Gå til toppen',
  },
  idField: {
    'en-us': 'ID Field',
    'es-es': 'Campo de identificación',
    'fr-fr': 'Champ ID',
    'ru-ru': 'Поле идентификатора',
    'uk-ua': 'Поле ідентифікатора',
    'de-ch': 'Feld-ID',
    'pt-br': 'Campo de identificação',
    'hr-hr': 'Polje za identifikaciju',
    nb: 'ID-felt',
  },
  tableUniquenessRules: {
    'en-us': '{tableName:string} Uniqueness Rules',
    'de-ch': '{tableName:string} Eindeutigkeitsregeln',
    'es-es': '{tableName:string} Reglas de unicidad',
    'fr-fr': "{tableName:string} Règles d'unicité",
    'ru-ru': '{tableName:string} Правила уникальности',
    'uk-ua': '{tableName:string} Правила унікальності',
    'pt-br': '{tableName:string} Regras de Unicidade',
    'hr-hr': '{tableName:string} Pravila jedinstvenosti',
    nb: '{tableName:string} Unikhetsregler',
  },
  uniquenessRules: {
    'en-us': 'Uniqueness Rules',
    'de-ch': 'Eindeutigkeitsregeln',
    'es-es': 'Reglas de singularidad',
    'fr-fr': "Règles d'unicité",
    'ru-ru': 'Правила уникальности',
    'uk-ua': 'Правила унікальності',
    'pt-br': 'Regras de singularidade',
    'hr-hr': 'Pravila jedinstvenosti',
    nb: 'Unikhetsregler',
  },
  uniqueFields: {
    'en-us': 'Unique Fields',
    'de-ch': 'Einzigartige Bereiche',
    'es-es': 'Campos únicos',
    'fr-fr': 'Champs uniques',
    'ru-ru': 'Уникальные поля',
    'uk-ua': 'Унікальні поля',
    'pt-br': 'Campos únicos',
    'hr-hr': 'Jedinstvena polja',
    nb: 'Unike felt',
  },
  addUniquenessRule: {
    'en-us': 'Add Uniqueness Rule',
    'de-ch': 'Eindeutigkeitsregel hinzufügen',
    'es-es': 'Agregar regla de unicidad',
    'fr-fr': "Ajouter une règle d'unicité",
    'ru-ru': 'Добавить правило уникальности',
    'uk-ua': 'Додати правило унікальності',
    'pt-br': 'Adicionar regra de unicidade',
    'hr-hr': 'Dodaj pravilo jedinstvenosti',
    nb: 'Legg til unikhetsregel',
  },
  configureUniquenessRule: {
    'en-us': 'Configure Uniqueness Rule',
    'de-ch': 'Eindeutigkeitsregel konfigurieren',
    'es-es': 'Configurar regla de unicidad',
    'fr-fr': "Configurer la règle d'unicité",
    'ru-ru': 'Настройка правила уникальности',
    'uk-ua': 'Налаштувати правило унікальності',
    'pt-br': 'Configurar regra de unicidade',
    'hr-hr': 'Konfiguriraj pravilo jedinstvenosti',
    nb: 'Konfigurer unikhetsregel',
  },
  scope: {
    'en-us': 'Scope',
    'es-es': 'Alcance',
    'fr-fr': 'Portée',
    'ru-ru': 'Объем',
    'uk-ua': 'Сфера застосування',
    'de-ch': 'Anwendungsbereich',
    'pt-br': 'Escopo',
    'hr-hr': 'Opseg',
    nb: 'Omfang',
  },
  uniquenessDuplicatesFound: {
    'en-us': 'Duplicates found in database',
    'de-ch': 'In der Datenbank gefundene Duplikate',
    'es-es': 'Se encontraron duplicados en la base de datos.',
    'fr-fr': 'Des doublons ont été trouvés dans la base de données.',
    'ru-ru': 'В базе данных обнаружены дубликаты.',
    'uk-ua': 'У базі даних знайдено дублікати',
    'pt-br': 'Foram encontrados duplicados no banco de dados.',
    'hr-hr': 'Duplikati pronađeni u bazi podataka',
    nb: 'Duplikater funnet i databasen',
  },
  exportDuplicates: {
    'en-us': 'Export Duplicates',
    'de-ch': 'Duplikate exportieren',
    'es-es': 'Exportar duplicados',
    'fr-fr': 'Exporter les doublons',
    'ru-ru': 'Экспорт дубликатов',
    'uk-ua': 'Експорт дублікатів',
    'pt-br': 'Exportar duplicados',
    'hr-hr': 'Izvoz duplikata',
    nb: 'Eksporter duplikater',
  },
  numberOfDuplicates: {
    'en-us': 'Number of Duplicates',
    'de-ch': 'Anzahl Duplikate',
    'es-es': 'Número de duplicados',
    'fr-fr': 'Nombre de doublons',
    'ru-ru': 'Количество дубликатов',
    'uk-ua': 'Кількість дублікатів',
    'pt-br': 'Número de duplicados',
    'hr-hr': 'Broj duplikata',
    nb: 'Antall duplikater',
  },
  schemaViewTitle: {
    'en-us': 'Schema Config: {tableName:string}',
    'es-es': 'Configuración del esquema: {tableName:string}',
    'fr-fr': 'Configuration du schéma : {tableName:string}',
    'ru-ru': 'Конфигурация схемы: {tableName:string}',
    'uk-ua': 'Конфігурація схеми: {tableName:string}',
    'de-ch': 'Schema-Konfiguration: {tableName:string}',
    'pt-br': 'Configuração do esquema: {tableName:string}',
    'hr-hr': 'Konfiguracija sheme: {tableName:string}',
    nb: 'Skjemakonfigurasjon: {tableName:string}',
  },
  schemaExportFileName: {
    'en-us': 'Specify 7 Data Model',
    'ru-ru': 'Укажите 7 моделей данных',
    'es-es': 'Especificar 7 modelos de datos',
    'fr-fr': 'Modèle de données Specify 7',
    'uk-ua': 'Specify 7 моделей даних',
    'de-ch': 'Specify 7 Datenmodell',
    'pt-br': 'Especifique 7 modelos de dados',
    'hr-hr': 'Navedite 7 podatkovnih modela',
    nb: 'Spesifiser 7 datamodell',
  },
  sortByHiddenFields: {
    'en-us': 'Sort by hidden fields',
    'de-ch': 'Nach ausgeblendeten Feldern sortieren',
    'es-es': 'Ordenar por campos ocultos',
    'fr-fr': 'Trier par champs cachés',
    'ru-ru': 'Сортировать по скрытым полям',
    'uk-ua': 'Сортувати за прихованими полями',
    'pt-br': 'Ordenar por campos ocultos',
    'hr-hr': 'Sortiraj po skrivenim poljima',
    nb: 'Sorter etter skjulte felt',
  },
  hidden: {
    'en-us': 'hidden',
    'de-ch': 'versteckt',
    'es-es': 'oculto',
    'fr-fr': 'caché',
    'ru-ru': 'скрытый',
    'uk-ua': 'прихований',
    'pt-br': 'escondido',
    'hr-hr': 'skriven',
    nb: 'skjult',
  },
  customFieldFormat: {
    'en-us': 'Custom Field Format',
    'de-ch': 'Format für benutzerdefinierte Felder',
    'es-es': 'Formato de campo personalizado',
    'fr-fr': 'Format de champ personnalisé',
    'ru-ru': 'Формат пользовательского поля',
    'uk-ua': 'Формат користувацького поля',
    'pt-br': 'Formato de campo personalizado',
    'hr-hr': 'Prilagođeni format polja',
    nb: 'Tilpasset feltformat',
  },
} as const);
